<template>
    <div :title="$t('sectionModalVersion.NovidadesVersao')">
      <b-modal
        v-model="abrir"
        v-bind:title="tituloAviso"
        size="lg"
        hide-footer
      >

        <form >  
            <div class="responsive-image">
                <a v-bind:href="linkUrlImg" target="_blank">
                    <img :src="'data:'+minitype+';base64,' + base64String" >
                </a>
            </div>
            <p></p>
            <div class="row">
                <div class="col-4 center">
                    <button class="btn btn-success" @click="FecharModal()" type="submit" >
                    {{ $t("sectionModalVersion.btnCiente") }}
                    </button>      
                    <input type="checkbox" v-model="isChecked" style="margin-left: 30px;" >
                    {{ $t("sectionModalVersion.naoExibir") }}       
                </div>
            </div>
        </form>
      </b-modal>
    </div>
  </template>
  
  <script>

const axios = require('axios').default;

  export default {
    name: "ModalVersion",
    data() {
      return {
        loading: false,
        abrir: true,
        isChecked:false,
        tituloAviso:"",
        base64String:"",
        minitype:"",
        linkUrlImg:"",
        idAviso:"",
      };
    },
    methods: {
        FecharModal(){
            if(this.isChecked){
                this.abrir = false
                window.localStorage.setItem('IdAviso', this.idAviso);
            }else{
                this.abrir = false
            }
        },
        VerificarAviso(){ 
            let vm = this

            axios.post('https://portal.prismafive.com.br/BannerSync/ObterTodosSync',{})
            .then(function (response) {
                if(response.data.length === 0) {
                    vm.abrir = false;
                    return;
                }

                vm.tituloAviso = response.data.nome; 
                vm.base64String =response.data.imagem;
                vm.minitype = response.data.mimeType;
                vm.linkUrlImg = response.data.url;
                vm.idAviso = response.data.id;
                window.localStorage.setItem('IdAvisoNovo', response.data.id);
            })
            .catch(function (error) {
                console.log(error);
            });

        }
    },
    created(){
        this.VerificarAviso();
        
    },
    beforeMount() {
            
        let id = localStorage.getItem('IdAviso')
        let idNovo = localStorage.getItem('IdAvisoNovo')

        if (id == idNovo ) {
            this.abrir = false
        }else{
            this.abrir = true
        }
    }
};
  </script>
  <style>
  .responsive-image {
    width: 100%;
    height: auto;
  }

  .responsive-image img {
    width: 100%;
    height: auto;
  }
</style>


  